export default {
  eventNames: {
    WEB_CAMERA: 'WEB_CAMERA',
    WEB_IMAGE_DATA: 'WEB_IMAGE_DATA',
    WEB_QR_DATA: 'WEB_QR_DATA',
    WEB_FILE: 'WEB_FILE_PICKER',
    WEB_FILE_SUCCESS: 'WEB_FILE_SUCCESS',
    WEB_FILE_ERROR: 'WEB_FILE_ERROR',
    ON_GO_BACK: 'onGoBack',
    WEB_IMAGE_ERROR: 'WEB_IMAGE_ERROR',
    WEB_QR_ERROR: 'WEB_QR_ERROR',
  },
};
